import IncPage from 'components/inc-page/inc-page.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IncPageTabPanelsProvider } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.context';
import IncPageTabPanels from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.component';
import IncPageHeader from 'components/inc-page/inc-page-header/inc-page-header.component';
import IncPageTitle from 'components/inc-page/inc-page-title/inc-page-title.component';
import { useSearchParams } from 'components/search/search.hooks';
import { useSMSReportsSearchParams } from './sms-reports-search/sms-reports-search.hooks';
import { SearchParamsProvider } from 'components/search/search.context';
import SMSReportsSearch from './sms-reports-search/sms-reports-search.component';
import { useIsFeatureFlagEnabled } from 'hooks/client-configuration.hooks';
import { FeatureFlag } from 'util/client-configuration';
import { useSetInitialTabAsDefault } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.hooks';

const SMSReportLanding = () => {
  const { t } = useTranslation();

  const isSMSMarketingFeatureEnabled = useIsFeatureFlagEnabled(
    FeatureFlag.SMSMarketing,
  );
  const isSMSOrderConfirmationFeatureEnabled = useIsFeatureFlagEnabled(
    FeatureFlag.SMSOrderConfirmation,
  );
  const isSMSAccountVerificationFeatureEnabled = useIsFeatureFlagEnabled(
    FeatureFlag.SMSAccountVerification,
  );
  const isSMSGuestCheckoutVerificationFeatureEnabled = useIsFeatureFlagEnabled(
    FeatureFlag.SMSGuestCheckoutVerification,
  );
  const isSMSPasswordlessAuthenticationFeatureEnabled = useIsFeatureFlagEnabled(
    FeatureFlag.SMSPasswordlessAuthentication,
  );

  const tabs = useMemo(() => {
    return [
      isSMSMarketingFeatureEnabled && {
        label: t('page.reportAndAnalytics.smsReports.sections.marketing.title'),
        path: 'marketing',
      },
      isSMSOrderConfirmationFeatureEnabled && {
        label: t(
          'page.reportAndAnalytics.smsReports.sections.orderConfirmation.title',
        ),
        path: 'orderconfirmation',
      },
      isSMSAccountVerificationFeatureEnabled && {
        label: t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.title',
        ),
        path: 'accountverification',
      },
      isSMSGuestCheckoutVerificationFeatureEnabled && {
        label: t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.title',
        ),
        path: 'guestcheckoutverification',
      },
      isSMSPasswordlessAuthenticationFeatureEnabled && {
        label: t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.title',
        ),
        path: 'passwordlessauthentication',
      },
    ].filter(Boolean);
  }, [
    isSMSMarketingFeatureEnabled,
    isSMSOrderConfirmationFeatureEnabled,
    isSMSAccountVerificationFeatureEnabled,
    isSMSGuestCheckoutVerificationFeatureEnabled,
    isSMSPasswordlessAuthenticationFeatureEnabled,
    t,
  ]);

  const searchParams = useSearchParams(useSMSReportsSearchParams());

  useSetInitialTabAsDefault(tabs);

  return (
    <IncPage>
      <SearchParamsProvider value={searchParams}>
        <IncPageTabPanelsProvider tabs={tabs}>
          <IncPageHeader>
            <IncPageTitle>
              {t('page.reportAndAnalytics.smsReports.title')}
            </IncPageTitle>
          </IncPageHeader>
          <SMSReportsSearch>
            <IncPageTabPanels />
          </SMSReportsSearch>
        </IncPageTabPanelsProvider>
      </SearchParamsProvider>
    </IncPage>
  );
};

export default SMSReportLanding;
